var style = {
  "MoreText": "_MoreText_ctnse_1",
  "Tooltip": "_Tooltip_ctnse_10"
};

export { style as default };
